import { WidgetProps } from '@rjsf/utils';

import { KeyValue } from '@/components/ui/keyValue/keyValue';

export const CheckboxWidget = ({
  label,
  value,
  options,
  name
}: WidgetProps) => {
  const { enumOptions } = options;

  /**
   * @returns a pair {label, value}
   */
  const selectedOption = enumOptions?.find(
    option => option.value === value
  ) || {
    label: value
  };

  return (
    <KeyValue title={label} dataCyName={name}>
      {selectedOption.label && <span>{selectedOption.label}</span>}
    </KeyValue>
  );
};

export default CheckboxWidget;
